<template>
  <div class="layout-container">

    <div class="header-container" ref="headerContainer">
      <div class="header-main wd-1200">
        <div class="header-website">{{websiteInfo.name}}</div>
        <div class="header-tabs">
          <el-tabs v-model="currentMenu" @tab-click="goTargetMenu">
            <el-tab-pane
              v-for="item in menuList"
              :key="`${item.router}_${item.moduleIndex}`"
              :label="item.showText || item.moduleName"
              :name="`${item.router}_${item.moduleIndex}`"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <div class="header-avatar">
          <el-dropdown @command="handleCommand">
            <div>
              <el-avatar v-if="isLogin()" src="https://yibaiserver-1252497236.file.myqcloud.com/yibai/default_user_avatar.png"></el-avatar>

              <span class="el-dropdown-link ellipsis-uniLine" v-if="!isLogin()">
                未登录
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
            </div>
            

            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout" v-if="isLogin()">退出登录</el-dropdown-item>
              <el-dropdown-item command="login" v-if="!isLogin()">登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <audioPlay />

      </div>
    </div>

    <div class="main-container" :style="{'min-height': `${minHeight}px`}">
      <transition name="fade">
        <router-view v-if="isShowRouterView"></router-view>
      </transition>
    </div>

    <div class="footer-container" ref="footerContainer">
      <div class="wd-1200">
        <div class="footer-container-info">
          <div class="header-tabs header-tabs_bottom">
            <el-tabs v-model="currentMenu" @tab-click="goTargetMenu">
              <el-tab-pane
                v-for="item in menuList"
                :key="`${item.router}_${item.moduleIndex}`"
                :label="item.showText || item.moduleName"
                :name="`${item.router}_${item.moduleIndex}`"
              ></el-tab-pane>
            </el-tabs>
          </div>
          <div class="bottom-text ellipsis-towLine">{{ websiteInfo.bottomImageText }}</div>
        </div>
        <div class="footer-container-QRCode">
          <div class="footer-container-QRCode_first" v-if="websiteInfo.bottomQrcode1">
            <img :src="websiteInfo.bottomQrcode1"/>
            <span class="ellipsis-uniLine">{{ websiteInfo.bottomQrcode1Text }}</span>
          </div>
          <div class="footer-container-QRCode_second" v-if="websiteInfo.bottomQrcode2">
            <img :src="websiteInfo.bottomQrcode2"/>
            <span class="ellipsis-uniLine">{{ websiteInfo.bottomQrcode2Text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { goSaasLoginPage } from '@/utils/index'
  import audioPlay from '@/components/pc/audioPlay';

export default {
  components: { audioPlay },
  data() {
    return {
      websiteInfo: this._websiteInfo,
      minHeight: 0,
      menuList: this._modules,
      currentMenu: '',
      isShowRouterView: true
    };
  },
  watch:{
    $route(newVal) {
      this.setMenuIndex(newVal)
    }
  },
  methods: {
    reload() {
      this.isShowRouterView = false

      this.$nextTick(() => {
        this.isShowRouterView = true
      })
    },
    
    isLogin() { // 是否登录
      return window.localStorage.getItem('Yibai-Token')
    },

    setMinHeight() {
      // 设置最小高度
      const clientHeight = document.documentElement.clientHeight;
      const headerHeight = this.$refs.headerContainer.offsetHeight;
      const footerHeight = this.$refs.footerContainer.offsetHeight;

      this.minHeight = clientHeight - (headerHeight + footerHeight);
    },
    goTargetMenu(item) {

      let externalLink = ''
      for (let i = 0; i < this.menuList.length; i ++) {
        const o = this.menuList[i]

        if (`${o.router}_${o.moduleIndex}` === item.name) {
          if (o.externalLink) {
            externalLink = o.externalLink
          }
          break
        }
      }
      if (externalLink){
        window.location.href = externalLink
      } else {
        const arr = item.name.split('_')
        const name = arr[0]
        const moduleIndex = arr[1]

        this.$router.push({
          name,
          params: {
            moduleIndex
          }
        })
      }
    },
    handleCommand(command) {
      if (command === 'login') { // 登录
        goSaasLoginPage()
        return
      }

      if (command === 'logout') { // 退出
        window.localStorage.removeItem('Yibai-Token')
        window.location.reload()
      }
    },
    setMenuIndex(route) {
      const { name, params } = route
      this.currentMenu = `${name}_${params.moduleIndex}`
    }
  },
  mounted() {
    this.setMinHeight();

    let resizeTag = true;
    window.onresize = () => {
      if (resizeTag) {
        this.setMinHeight();

        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 100);
      }
    };
  },
  created() {
    this.menuList = [
      {
        id: -1,
        moduleName: '首页',
        router: 'index'
      },
      ...this.menuList
    ]

    this.setMenuIndex(this.$route)
  },
};
</script>

<style lang="scss">
  .layout-container {

    .header-container {
      height: 64px;
      background-color: var(--themeColor);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left-box {
        .logo {
        }

        .meet-name {
        }
      }

      .header-main {
        // overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;

        // flex-wrap: nowrap;
        position: relative;

        .header-main-logo {
          width: 94px;
          height: 50px;
          padding-top: 7px;
          // display: inline-block;
        }

        .header-website {
          padding: 0 10px 0 0;
          line-height: 20px;
          font-size: 14px;
          color: #fff;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
        }

        .header-tabs {
          flex:1;
          max-width: 850px;
          .el-tabs__header{
            margin: 0;
          }

          .el-tabs__item {
            color: #fff;
            padding: 0 10px;
            opacity: 0.8;
          }

          .el-tabs__item.is-active {
            font-weight: bold;
            opacity: 1;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__active-bar {
            border-radius: 5px;
            background-color: #fff;
            height: 6px;
          }
          .el-tabs__nav-next, .el-tabs__nav-prev{
            color:#fff;
            margin-top:-2px;
          }
        }

        .header-avatar {
          max-width: 100px;
          height: 40px;
          min-width: 100px;
          line-height: 40px;
          overflow: hidden;

          .el-dropdown {
            font-size: 16px;
            color: #fff;
            float: right;
            cursor: pointer;
          }

          .el-dropdown-link {
            max-width: 80px;
            display: inline-block;
            margin-left: 16px;
          }
        }
      }
    }

    .footer-container {
      height: 178px;
      background-color: #282828;
      color: #fff;

      > div {
        height: 178px;

        .footer-container-info {
          height: 178px;
          width: 76%;
          float: left;

          .bottom-text {
            width: 70%;
            line-height: 28px;
            font-size: 14px;
            color: #eee;
            margin: 0;
            padding: 0;
          }

          .header-tabs {
            margin: 26px 0 26px;
            display: inline-block;

            .el-tabs__header {
              margin: 0;
            }

            .el-tabs__item {
              font-size: 18px;
              color: #eee;
              padding: 0 20px 0 0;
            }

            .el-tabs__item.is-active {
              font-weight: bold;
              opacity: 1;
            }

            .el-tabs__item:hover {
              /*color: var(--themeColor);*/
              font-weight: bold;
            }

            .el-tabs__nav-wrap::after {
              display: none;
            }

            .el-tabs__active-bar {
              border-radius: 5px;
              background-color: #fff;
              height: 0;
            }
          }

          .header-tabs_bottom {
            max-width: 890px
          }
        }

        .footer-container-QRCode {
          height: 178px;
          width: 24%;
          float: left;
          display: flex;
          justify-content: space-around;
          align-items: center;

          img {
            width: 96px;
            height: 96px;
            display: inline-block;
          }

          .footer-container-QRCode_first,
          .footer-container-QRCode_second {
            display: inline-block;

            span {
              width: 96px;
              display: block;
              font-size: 14px;
              text-align: center;
              padding-top: 8px;
            }
          }
        }
      }
    }
  }
</style>
